import { render, staticRenderFns } from "./AddressListLeft.vue?vue&type=template&id=8357612a&scoped=true"
import script from "./AddressListLeft.vue?vue&type=script&lang=js"
export * from "./AddressListLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8357612a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8357612a')) {
      api.createRecord('8357612a', component.options)
    } else {
      api.reload('8357612a', component.options)
    }
    module.hot.accept("./AddressListLeft.vue?vue&type=template&id=8357612a&scoped=true", function () {
      api.rerender('8357612a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/AddressListLeft.vue"
export default component.exports